import { BADGE1_TYPE, BADGE_TYPE, BEZIER_TYPE, BITMAP_TYPE, CURVED_TEXT_TYPE, IMAGE_FROM_ELEMENTS_TYPE, LINE_TYPE, POLYGON_TYPE, TEXT_INSIDE_SHAPE_TYPE } from "shape-entities/types/shape"
import React from "react";
import BadgeForm from "./badge-form";
import BitmapForm from "./bitmap-form";
import PolygonForm from "./polygon-form";
import PathForm from "./path-form";

const ShapeSpecificFormAfter = ({ form, formName, change, shape }): JSX.Element => {
    switch (shape?.type) {
        case BITMAP_TYPE:
            return <BitmapForm form={form} formName={formName} change={change} shape={shape} />
        case LINE_TYPE:
        case POLYGON_TYPE:
            return <PolygonForm form={form} formName={formName} change={change} shape={shape} />
        case CURVED_TEXT_TYPE:
        case TEXT_INSIDE_SHAPE_TYPE:
        case BEZIER_TYPE:
            return <PathForm form={form} formName={formName} change={change} shape={shape} />
        default:
            return <div />
    }
}

export default ShapeSpecificFormAfter